import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { UserMapSkill } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/usermapskill" component={UserMapSkill} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/UserMapSkill/routes.js